import { render, staticRenderFns } from "./MessageInfoList.vue?vue&type=template&id=2110e9b6&scoped=true"
import script from "./MessageInfoList.vue?vue&type=script&lang=js"
export * from "./MessageInfoList.vue?vue&type=script&lang=js"
import style0 from "./MessageInfoList.vue?vue&type=style&index=0&id=2110e9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110e9b6",
  null
  
)

export default component.exports